<div class="chip">
    <span class="material-symbols-rounded">{{ data?.icon }}</span>
    <span class="label">{{ data?.label }}:</span>
    <span class="value">{{ data?.value }}</span>
    <span class="material-symbols-rounded close-icon"
          (click)="removeParameter()">close</span>
</div>
